// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"89986f96","455":"551732bc","977":"c6d944d3"}[chunkId] + ".chunk.js";
};